import { useState } from 'react';
import { FilePlus } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { BillFormDialog } from './BillFormDialog';

export default function CreateBill({ onCreated }) {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <div className="space-y-6">
      <Card className="border-dashed border-zinc-700">
        <CardContent className="flex flex-col items-center justify-center py-16 gap-4">
          <FilePlus className="w-12 h-12 text-zinc-600" strokeWidth={1} />
          <p className="text-zinc-400 text-sm">Create a new invoice for one of your clients</p>
          <Button onClick={() => setShowDialog(true)} data-testid="new-bill-btn">
            <FilePlus className="w-4 h-4 mr-2" /> New Bill
          </Button>
        </CardContent>
      </Card>

      <BillFormDialog
        open={showDialog}
        onOpenChange={setShowDialog}
        bill={null}
        onSaved={onCreated}
      />
    </div>
  );
}
